export default __webpack_public_path__ + "static/media/rps.a5df6b58.png";